import util from '@/libs/util'

const post = util.ajax.post
const get = util.ajax.get

export const orderUrls = [
  // 查询
  '/order/list',
  // 结账
  '/order/pay',
  // 作废
  '/order/delete',
  // 判断该车牌是否存在 维修中 的工单
  '/order/exist',
  // 接车
  '/order/save',
  // 编辑
  '/order/update',
  // 明细
  '/order/detail',
  // 更新尾气数据(仅新增时可用)
  '/exhaust/detection/list'
]

export const order = {}

order.listOrder = function (params) {
  return post('/order/list', params)
}
order.payOrder = function (params) {
  return post('/order/pay', params)
}
order.deleteOrder = function (params) {
  return post('/order/delete', params)
}
order.existOrder = function (params) {
  return post('/order/exist', params)
}
order.saveOrder = function (params) {
  return post('/order/save', params)
}
order.updateOrder = function (params) {
  return post('order/update', params)
}
order.detailOrder = function (params) {
  return post('order/detail', params)
}
order.detailOrderFromI = function (params) {
  return post('order/detailByi', params)
}
order.listExhaust = function (params) {
  return get(`/exhaust/detection/list?plateNumber=${params.plateNumber}&plateNumberColor=${params.plateNumberColor}`)
}
order.uploadGovern = function (params) {
  return post('order/uploadGovern', params)
}
order.getToken = function () {
  return get('order/qrcodeToken')
}
order.getQrCodeUrl = function (params) {
  return post('order/qrcodeUrl', params)
}



// WEBPACK FOOTER //
// ./src/api/gip/repair/order.js